// @ts-nocheck
import React, { useState } from "react";
import Header from "../layout/Header";
import { TiTick } from "react-icons/ti";

import { useFormik } from "formik";
import * as Yup from "yup";
import { error_toaster, success_toaster } from "../../toaster/Toaster";
import { PostApi } from "../../../ApiClient/PostApi";
import { Loader2 } from "../../loader/Loader";
import Footer from "../layout/Footer";
export default function Support() {
  const [loading, setLoading] = useState(false);
  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    country: "",
    postalCode: "",
  };
  const ValidationSchema = Yup.object({
    email: Yup.string().email().required("Please enter your email"),
    firstName: Yup.string().required("Please enter First Name"),
    lastName: Yup.string().required("Please enter Last Name"),
    country: Yup.string().required("Please enter Country Name"),
    postalCode: Yup.string().required("Please enter Postal Code"),
  });
  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema: ValidationSchema,
      onSubmit: async (values, action) => {
        setLoading(true);

        let res = await PostApi("users/home/add_contact_message", {
          firstName: values.firstName,
          lastName: values.lastName,
          country: values.country,
          postalCode: values.postalCode,
          email: values.email,
          message: values.message,
          companyName: values.companyName,
        });

        if (res.data.status === "1") {
          setLoading(false);
          values.firstName = "";
          values.lastName = "";
          values.country = "";
          values.postalCode = "";
          values.email = "";
          values.message = "";
          values.companyName = "";
          success_toaster(res.data.message);
        } else {
          setLoading(false);
          error_toaster(res.data.message);
        }
      },
    });
  return (
    <>
      <section className="font-soehne">
        <Header />
        <div className="bg-[#638DB4]">
          <form onSubmit={handleSubmit}>
            {loading ? (
              <Loader2 />
            ) : (
              <>
                <div className="grid space-y-4 lg:grid-cols-2 mx-auto pt-24 w-4/5 py-16">
                  <div className="text-white space-y-6">
                    <p className=" text-3xl">Contact our support team</p>
                    <p className=" text-sm font-mono">
                      We're happy to answer your questions and help you become
                      conversant
                    </p>
                    {/* <div className="space-y-4">
                        <div className="flex gap-x-4 items-center">
                          <TiTick /> <p>Learn how to register on platform</p>
                        </div>
                        <div className="flex gap-x-4 items-center">
                          <TiTick /> <p>Learn how to register on platform</p>
                        </div>
                        <div className="flex gap-x-4 items-center">
                          <TiTick /> <p>Learn how to register on platform</p>
                        </div>
                      </div> */}
                  </div>
                  <div className="py-10 md:py-2">
                    <div className="bg-white h-[700px] w-full rounded p-6 space-y-6 shadow">
                      <p className="text-themeBlue text-2xl text-center">
                        Contact Us
                      </p>
                      <div className="grid lg:grid-cols-2 gap-x-2 gap-y-4">
                        <div className="">
                          <input
                            name="firstName"
                            value={values.firstName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="First Name"
                            className="w-full border border-gray-300 font-normal  px-5 py-2 rounded placeholder:text-black placeholder:text-opacity-40 focus:outline-none"
                          />
                          {errors.firstName && touched.firstName && (
                            <div className="px-5 text-red-600 space-y-1 pb-1">
                              {/*  */}
                              <p>{errors.firstName}</p>
                            </div>
                          )}
                        </div>
                        <div>
                          <input
                            name="lastName"
                            value={values.lastName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Last Name"
                            className="w-full border border-gray-300 font-normal  px-5 py-2 rounded placeholder:text-black placeholder:text-opacity-40 focus:outline-none"
                          />
                          {errors.lastName && touched.lastName && (
                            <div className="px-5 text-red-600 space-y-1 pb-1">
                              <p>{errors.lastName}</p>
                            </div>
                          )}
                        </div>
                      </div>
                      <div>
                        <input
                          name="companyName"
                          value={values.companyName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Company Name(optional)"
                          className=" w-full border border-gray-300 font-normal  px-5 py-2 rounded placeholder:text-black placeholder:text-opacity-40 focus:outline-none"
                        />
                        {errors.companyName && touched.companyName && (
                          <div className="px-5 text-red-600 space-y-1 pb-1">
                            <p>{errors.companyName}</p>
                          </div>
                        )}
                      </div>
                      <div>
                        <input
                          name="email"
                          placeholder="christoff@pacifricaxp.com"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className="w-full border border-gray-300 font-normal  px-5 py-2 rounded placeholder:text-black placeholder:text-opacity-40 focus:outline-none"
                        />
                        {errors.email && touched.email && (
                          <div className="px-5 text-red-600 space-y-1 pb-1">
                            <p>{errors.email}</p>
                          </div>
                        )}
                      </div>
                      <div className="grid lg:grid-cols-2  gap-x-2 gap-y-4">
                        <div>
                          <input
                            name="country"
                            value={values.country}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Country"
                            className="w-full border border-gray-300 font-normal  px-5 py-2 rounded placeholder:text-black placeholder:text-opacity-40 focus:outline-none"
                          />
                          {errors.country && touched.country && (
                            <div className="px-5 text-red-600 space-y-1 pb-1">
                              <p>{errors.country}</p>
                            </div>
                          )}
                        </div>
                        <div>
                          <input
                            name="postalCode"
                            value={values.postalCode}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Postal Code"
                            className="w-full border border-gray-300 font-normal  px-5 py-2 rounded placeholder:text-black placeholder:text-opacity-40 focus:outline-none"
                          />
                          {errors.postalCode && touched.postalCode && (
                            <div className="px-5 text-red-600 space-y-1 pb-1">
                              <p>{errors.postalCode}</p>
                            </div>
                          )}
                        </div>
                      </div>
                      <div>
                        <textarea
                          name="message"
                          value={values.message}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          rows={4}
                          placeholder="Type here... (optional)"
                          className=" w-full border border-gray-300 font-normal  px-5 py-2 rounded placeholder:text-black placeholder:text-opacity-40 focus:outline-none"
                        />
                        {errors.message && touched.message && (
                          <div className="px-5 text-red-600 space-y-1 pb-1">
                            <p>{errors.message}</p>
                          </div>
                        )}
                      </div>
                      <div className="flex justify-end">
                        <button
                          type="submit"
                          className="py-2 bg-themeBlue border border-themeBlue text-white px-4 rounded hover:bg-white hover:text-themeBlue"
                        >
                          Send Message
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </form>
        </div>
        <Footer />
      </section>
    </>
  );
}
